/* global YT, Vimeo */

if (!customElements.get('reviews-carousel')) {
  class Reviews extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
    }

    init() {
      const slider = new Swiper(this, {
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 26,
        slideToClickedSlide: true,
        loop: true,
        autoHeight: true,
        pagination: { el: ".swiper-pagination", clickable: true},
        autoplay: {
          enabled: this.dataset.autoplay ? true : false,
          delay: this.dataset.autoplay,
          pauseOnMouseEnter: true,
          disableOnInteraction: false,
        },
      });
    }
  }

  customElements.define('reviews-carousel', Reviews);
}
